var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$vuetify.goTo(0)}}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.general.backToTop'))+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-chevron-up")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }